import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { LocationData } from '../../models/location-data';

export const locationDataAdapter: EntityAdapter<LocationData> = createEntityAdapter<LocationData>({ selectId: model => model.gbpLocationId });